import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { squashString } from 'ggtmo-utils';

// Components
import { Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck, faMapPin, faTimes, faRandom,
} from '@fortawesome/pro-light-svg-icons';
import TableCell from '@material-ui/core/TableCell';
import MatTable from '../../../shared/components/table/MatTable';

const tableColumns = [
  {
    id: 'title', label: 'Title', disablePadding: false, numeric: false, align: 'left',
  },
  {
    id: 'isLive', label: 'Live', disablePadding: false, numeric: false, align: 'left',
  },
  {
    id: 'dateCreated', label: 'Date Created', disablePadding: false, numeric: false, align: 'left',
  },
];

const TableRow = ({
  id,
  title,
  isLive,
  dateTimeCreated,
  createdFromEvent,
  pinned,
}) => (
  <>
    <TableCell className="material-table__cell">
      {squashString(title, { length: 80 })}
      {createdFromEvent && (
        <>
          <Link to={`/events/editor/${createdFromEvent.id}`}>
            <span
              className="text-primary float-right ml-2"
              id={`converted-from-event-${id}`}
            >
              <FontAwesomeIcon icon={faRandom} fixedWidth />
              {' '}Created from an event
            </span>
          </Link>
          <UncontrolledTooltip target={`converted-from-event-${id}`}>
            This story was created from a converted event.
          </UncontrolledTooltip>
        </>
      )}
      {pinned && (
        <>
          <span className="text-primary float-right" id="pinned-row">
            <FontAwesomeIcon icon={faMapPin} fixedWidth />
            {' '}Pinned
          </span>
          <UncontrolledTooltip target="pinned-row">
            This story will appear in the first spot on the home page.
          </UncontrolledTooltip>
        </>
      )}
    </TableCell>
    <TableCell className="material-table__cell">
      {isLive ? (
        <FontAwesomeIcon icon={faCheck} className="text-primary" fixedWidth />
      ) : (
        <FontAwesomeIcon icon={faTimes} className="text-danger" fixedWidth />
      )}
    </TableCell>
    <TableCell className="material-table__cell">{moment(dateTimeCreated).format('DD/MM/YYYY')}</TableCell>
  </>
);

TableRow.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  isLive: PropTypes.bool.isRequired,
  dateTimeCreated: PropTypes.string.isRequired,
  createdFromEvent: PropTypes.bool.isRequired,
  pinned: PropTypes.bool.isRequired,
};

const NewsTable = ({
  children,
  stories,
  selected,
  page,
  count,

  // Callbacks
  onSelect,
  onPageChange,
}) => (
  <div>
    <MatTable
      rowComponent={TableRow}
      columns={tableColumns}
      data={stories}
      selected={selected}
      page={page}
      count={count}

      // Callbacks
      onSelect={onSelect}
      onPageChange={onPageChange}
    >
      {children}
    </MatTable>
  </div>
);

NewsTable.propTypes = {
  children: PropTypes.node,
  stories: PropTypes.instanceOf(Array).isRequired,
  selected: PropTypes.instanceOf(Array).isRequired,
  page: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,

  // Callbacks
  onSelect: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

NewsTable.defaultProps = {
  children: null,
};

export default NewsTable;
